// extracted by mini-css-extract-plugin
module.exports = {"cardGroup":"_9bdc84c","card":"_5dd72ef"};